import { combineReducers } from 'redux';
import notifications from './notificationsReducer';

export default combineReducers({
    notifications
});
